import React from 'react'
import { useSelector } from 'react-redux'
import classnames from 'classnames'

import ItemsLoading from '../../../../../components/Loaders/ItemsLoading'
import PageSection from '../../../../../features/components/PageSection'
import GoogleAssetGroupPreviewCard from './GoogleAssetGroupPreviewCard'
import GoogleAdPreviewCard from './GoogleAdPreviewCard'
import SkeletonGoogleAdPreviewCard from './GoogleAdPreviewCard/Skeleton'
import DisapproveAssetGroupModal from '../DisapproveAssetGroupModal'
import DisapproveInternalAdModal from '../../../DisapproveInternalAdModal'

import useModalManage from '../../../../../hooks/useModalManage'

import {
  assetGroupsIsLoadingSelector,
  assetGroupsErrorSelector,
  assetGroupsWasLoadedSelector
} from '../../../../../modules/selectors/assets'
import { adsIsLoadingSelector } from '../../../../../modules/selectors/ads'

import useStyles from './styles'

const GoogleAdsPreviewList = ({ assetGroups = [], ads = [], noDataText }) => {
  const classes = useStyles()

  const assetGroupsIsLoading = useSelector(assetGroupsIsLoadingSelector)
  const adsIsLoading = useSelector(adsIsLoadingSelector)

  const {
    isModalOpened: isDisapproveAssetGroupModalOpened,
    openModalHandler: disapproveAssetGroupOpenModalHandler,
    closeModalHandler: disapproveAssetGroupCloseModalHandler,
    modalData: disapproveAssetGroupModalData
  } = useModalManage({})

  const {
    isModalOpened: isDisapproveInternalAdModalOpened,
    openModalHandler: disapproveInternalAdOpenModalHandler,
    closeModalHandler: disapproveInternalAdCloseModalHandler,
    modalData: disapproveInternalAdModalData
  } = useModalManage({})

  return (
    <>
      <ItemsLoading
        itemsLength={assetGroups.length || ads.length}
        className={classnames({
          // minor tweak to use cardsList class while showing skeletons to keep grid styles
          [classes.cardsList]: assetGroupsIsLoading || adsIsLoading
        })}
        noDataText={noDataText}
        isLoadingSelector={assetGroupsIsLoadingSelector}
        wasLoadedSelector={assetGroupsWasLoadedSelector}
        errorSelector={assetGroupsErrorSelector}
        additionalDataIsLoading={adsIsLoading}
        initialLoadingSkeletonsNumber={4}
        SkeletonComponent={SkeletonGoogleAdPreviewCard}
        ContentWrapper={PageSection}
      >
        <div className={classes.cardsList}>
          {/*we combine assets groups with usual ads to show in one section */}
          {assetGroups.map(assetGroup => (
            <GoogleAssetGroupPreviewCard
              key={assetGroup?.id}
              assetGroup={assetGroup}
              disapproveInternalAssetGroupHandler={() => disapproveAssetGroupOpenModalHandler(assetGroup)}
            />
          ))}
          {ads.map(ad => (
            <GoogleAdPreviewCard
              key={ad.id}
              ad={ad}
              disapproveInternalAdHandler={() => disapproveInternalAdOpenModalHandler(ad)}
            />
          ))}
        </div>
      </ItemsLoading>
      <DisapproveAssetGroupModal
        isModalOpened={isDisapproveAssetGroupModalOpened}
        modalData={disapproveAssetGroupModalData}
        onClose={disapproveAssetGroupCloseModalHandler}
      />
      <DisapproveInternalAdModal
        isModalOpened={isDisapproveInternalAdModalOpened}
        modalData={disapproveInternalAdModalData}
        onClose={disapproveInternalAdCloseModalHandler}
      />
    </>
  )
}

export default GoogleAdsPreviewList
